import Cookies from "js-cookie";

export interface ExistingAccountCookie {
  accountId: number;
  username: string;
  ts: number;
}

const COOKIE_NAME = "existing_account";
const COOKIE_EXPIRY_DAYS = 365; // long-lived to recognize returning users

export function hasExistingAccountCookie(): boolean {
  return typeof Cookies.get(COOKIE_NAME) === "string";
}

export function getExistingAccountCookie(): ExistingAccountCookie | null {
  try {
    const value = Cookies.get(COOKIE_NAME);
    if (!value) {
      return null;
    }
    const parsed: ExistingAccountCookie = JSON.parse(value);
    if (
      typeof parsed.accountId === "number" &&
      typeof parsed.username === "string" &&
      typeof parsed.ts === "number"
    ) {
      return parsed;
    }
    return null;
  } catch (err) {
    return null;
  }
}

export function setExistingAccountCookie(accountId: number, username: string): void {
  const payload: ExistingAccountCookie = {
    accountId,
    username,
    ts: Date.now(),
  };
  Cookies.set(COOKIE_NAME, JSON.stringify(payload), {
    expires: COOKIE_EXPIRY_DAYS,
    path: "/",
    sameSite: "Lax",
  });
}

export function clearExistingAccountCookie(): void {
  Cookies.remove(COOKIE_NAME, { path: "/" });
}


